module.exports = __webpack_public_path__ + "media/images/pic/zadowolone-dzieci-6aa006f420e6a4bf2fdd5eb1c6b6f061.png";